let baseUrl = 'https://assets.in-cdn.net/static/frontend/'

// if (process.env.NODE_ENV === 'development') {
//     baseUrl = '/static/frontend/'
// }

// if (process.env.NODE_ENV === 'stage') {
//     baseUrl = 'https://assets.stage.in-cdn.net/static/frontend/'
// }

export { baseUrl }
